import { useQuery } from '@tanstack/react-query';
import { installmentsQueryKey } from './keys';
import { normalizeInstallment, sortInstallments } from '../types';
import type { InstallmentDto, InstallmentsHttpRequest, RawInstallmentDto } from '../types';

export interface UseInstallmentsParams {
  documentId: string;
  /**
   * Endpoint GET del plan de cuotas (BRECHA G1). Si se omite, la query queda
   * deshabilitada y la grilla se puebla solo con `initialData` / mutaciones.
   */
  installmentsEndpoint?: string;
  httpRequest: InstallmentsHttpRequest;
  /** Datos iniciales (p.ej. provenientes de la sección FactBox del adapter). */
  initialData?: InstallmentDto[];
  enabled?: boolean;
}

/**
 * Carga el plan de cuotas del documento (lo que la grilla renderiza).
 *
 * Cache key: `['document-installments', documentId]`. Normaliza el
 * `autoGeneratedSnapshot` (objeto o string JSON) y ordena por `installmentNumber`.
 */
export function useInstallments({
  documentId,
  installmentsEndpoint,
  httpRequest,
  initialData,
  enabled = true,
}: UseInstallmentsParams) {
  return useQuery<InstallmentDto[]>({
    queryKey: installmentsQueryKey(documentId),
    enabled: enabled && Boolean(documentId) && Boolean(installmentsEndpoint),
    initialData: initialData ? sortInstallments(initialData) : undefined,
    queryFn: async () => {
      const raw = await httpRequest<RawInstallmentDto[]>('GET', installmentsEndpoint!);
      return sortInstallments((raw ?? []).map(normalizeInstallment));
    },
  });
}
